import React, { useEffect, useState } from "react"

import MetaTags from "react-meta-tags"
import { Container } from "reactstrap"
import { withRouter } from "react-router-dom"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import ProductsTable from "./ProductsTable"
import { useSelector, useDispatch } from "react-redux"
import { getAllProducts } from "store/products/actions"
import {sitename} from "../../../constants/constants";

const Products = props => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getAllProducts())
  }, [])

  const Products = useSelector(state => state?.products?.Index ?? [])

  return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>{sitename}</title>
          </MetaTags>
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs title="Settings" breadcrumbItem="Products" />
            <ProductsTable Products={Products} />
          </Container>
        </div>
      </React.Fragment>
  )
}

export default withRouter(Products)
